<template>
  <f7-popup class="popup-user-reset-password" :id="nameId" :opened="popupOpened"
    @popup:opened="popupOpened = true"
    @popup:closed="popupOpened = false"
    style="height: 200px !important">
    <div class="container-user-reset-password">
      <br/>
      <b-row>
        <b-col cols="8" offset="2" class="form-group">
          <label>{{ $t('common.idtfr') }} <span style="color: red">*</span></label>
          <div class="form-control"
            style="display:flex;height: 40px;">
            <input v-model="login"
              inputType="text"
              style="border:none;width: 100%;"
              :placeholder="$t('common.idtfr')">
            </input>
          </div>
        </b-col>
      </b-row>
      <!--<form-write-group-label-input v-model="login" isMandatory
        :inputLabel="$t('common.idtfr')" :placeholderValue="$t('common.idtfr')"
        inputType="text">
      </form-write-group-label-input>-->
      <b-row class="loginButtons">
        <b-col cols="8" offset="2">
          <b-button variant="primary" size="lg"
            @click="resetPassword()">
            {{ $t('administration.reset_password') }}
          </b-button>
        </b-col>
      </b-row>
      <!--<button round class="button-action milkyBlockBlack" @click="resetPassword()">{{ $t('administration.reset_password') }}</button>-->
    </div>
  </f7-popup>
</template>

<script>

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  name: 'cm-user-reset-password',
  props: {
    closeButton: Boolean
  },
  data: () => {
    return {
      popupOpened: false,
      nameId: '',
      login: ''
    }
  },
  created () {
    this.nameId = 'cm-user-reset-password-' + this.closeButton
  },
  methods: {
    resetPassword () {
      let that = this
      this.$f7.modal({
        title: 'Reset password in progress',
        text: '<span class="preloader"></span>'
      })
      this.$engine.firstOn().user.resetPassword(this.login)
      .then(resp => {
        setTimeout(function () {
          that.$f7.closeModal()
          if (resp.status === 200) {
            that.$f7.modal({
              title: 'Email sent',
              text: 'An email has been sent to your mail box if your account exist'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/login/', force: false, ignoreCache: false})
            }, 2000)
          }
        }, 1000)
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    }
  }
}
</script>

<style scoped>
.popup-user-reset-password {
  border-radius: 15px;
  background-color: rgba(255, 255, 255, .95);
  height: 180px;
  width: 50%;
}
.container-user-reset-password {
  margin: 10px;
}
</style>
